import {CommonMessages} from '../common.messages';

export const AddFeeMessages = {
    FeeAssignmentFailed: {
        key: 'FeeAssignmentFailed',
        message: 'Unable to assign fee <<fee>> to account with reference <<reference>>.'
    },
    FeeUpdateFailed: {
        key: 'FeeAssignmentFailed',
        message: 'Unable to update fee <<fee>> validity to account with reference <<reference>>.'
    },
    FeeIsAlreadyAssigned: {
        key: 'FeeIsAlreadyAssigned',
        message: 'fee <<fee>> is already assigned to account with reference <<reference>>.'
    },
    FeeAssignmentSucceed: {
        key: 'FeeAssignmentSucceed',
        message: 'Fee is successfully assigned.'
    },
    FeeUpdateSucceed: {
        key: 'FeeUpdateSucceed',
        message: 'Fee is successfully updated.'
    },
    FeeUnassignedSucceed: {
        key: 'FeeUnassignedSucceed',
        message: 'Fee is successfully unassigned.'
    },
    GetFeesFailed: {
        key: 'GetFeesFailed',
        message: 'Unable to get fees for selected plan.'
    },
    WrongEndDateValue: {
        key: 'WrongEndDateValue',
        message: 'Valid to must be greater than Valid from'
    },
    EqualDataValue: {
        key: 'EqualDataValue',
        message: 'Valid from and Valid to dates can not be the same'
    },
    ...CommonMessages
};
